import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import getUserAgent from '@/util/getUserAgent';
import getUrlParam from '@/util/getUrlParam';
export default {
  namespaced: true,
  // 服务端运行时state需要改成函数形式，避免成为单例
  state: function state() {
    return {
      welfare: null
    };
  },
  mutations: {
    saveWelfare: function saveWelfare(state, welfare) {
      state.welfare = welfare;
    }
  },
  actions: {
    /**
     * 请求福利社数据接口
     * @param subPageInfo 请求二级页信息
     * @param pageInfo 请求主页面分页信息
     * @returns {Promise.<void>}
     */getWelfare: function () {
      var _getWelfare = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
        var commit,
          rootState,
          subPageInfo,
          ua,
          platform,
          isPreRelease,
          param,
          welfare,
          _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref.commit, rootState = _ref.rootState;
                subPageInfo = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                ua = getUserAgent(rootState.ctxInfo);
                platform = ua.indexOf('iPhone') >= 0 ? 7 : 8; // iPlatForm;//平台 iphone 7 android 8
                isPreRelease = getUrlParam('is_prepublish', rootState.ctxInfo) ? 1 : 0;
                param = {
                  subPageInfo: subPageInfo,
                  platform: platform,
                  isPreRelease: isPreRelease
                };
                _context.next = 8;
                return DataRequest('welfare', param, rootState.ctxInfo);
              case 8:
                welfare = _context.sent;
                welfare.data.vModList.forEach(function (item) {
                  item.data = item.iModType === 0 ? item.tCommData : item.tMultiData;
                });
                commit('saveWelfare', welfare.data);
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function getWelfare(_x) {
        return _getWelfare.apply(this, arguments);
      }
      return getWelfare;
    }()
  }
};